import React, {useState} from "react";
import { Modal } from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";

const DocumentFormModal = ({setDocuments}) => {
  const [loading, setLoading] = useState(false);
  const state = useSelector((state) => {
    return {
      organizationName: state.organization.name,
      affiliateMemberId: state.affiliateMember.id,
    }
  });
  const { show } = useSelector((state) => state.ui.documentModal);
  const dispatch = useDispatch();

  const handleClose = () => {
    setLoading(false);
    dispatch({ type: "CLOSE_RESOURCE_MODAL", payload: { resourceName: "document" } })
  };

  const handleChange = (e) => {
    const {organizationName, affiliateMemberId} = state;

    const formData = new FormData();
    formData.append(
      "document[name]",
      e.target.files[0].name
    );
    formData.append(
      "document[asset]",
      e.target.files[0]
    );

    setLoading(true);
    $.ajax({
      url: `/organizations/${organizationName}/affiliate_members/${affiliateMemberId}/documents.json`,
      method: "POST",
      data: formData,
      processData: false,
      cache: false,
      contentType: false,
      success: (data) => {
        setDocuments((documents) => [data, ...documents]);
        handleClose();
      }
    });
  }

  return (
    <Modal show={show} onHide={() => handleClose()}>
      <Modal.Header closeButton>
        <Modal.Title>Document</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {loading ? (
            <div>Please wait. Uploading...</div>
          ) : (
            <div className="d-flex justify-content-between">
              <label className="btn btn-sm btn-info m-0">
                Choose File
                <input
                  type="file"
                  className="sr-only"
                  onChange={handleChange}
                />
              </label>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DocumentFormModal;
